import {
  TITLE,
  TITLE_DATA_STANDARDS,
} from 'jl-design-system/form/fields';

export default function titleField(useTitleDropdown) {
  const titleFieldConfig = useTitleDropdown ? TITLE_DATA_STANDARDS : TITLE;

  if (useTitleDropdown) {
    titleFieldConfig.required = true;
    titleFieldConfig.optional = false;

    titleFieldConfig.className = 'fieldSmall';

    titleFieldConfig.validationMessageKeys = {
      ...titleFieldConfig.validationMessageKeys,
      notInOptions: 'Please select a title',
    };
  }

  return titleFieldConfig;
}
